module.exports = __webpack_public_path__ + "img/17.d3250a30.jpg";